import React from "react";
import { useI18n } from "../i18n/I18nContext";
import { useSite } from "../context/SiteContext";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { FaqSection } from "../components/FaqSection";

export default function InfosPage() {
  const { t } = useI18n();
  const { settings } = useSite();

  return (
    <div>
      <PageHero title={t("infosPage.title")} subtitle={t("infosPage.subtitle")} image={settings.gallery?.[2] || settings.hero_image} crumb={t("nav.infos")} />

      <section className="py-16 lg:py-24">
        <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 grid sm:grid-cols-2 gap-5">
          {t("infosPage.sections").map(([title, text], i) => (
            <Reveal key={i} delay={(i % 2) * 80}>
              <div className="bg-white rounded-2xl border border-black/5 p-6 h-full">
                <h3 className="font-heading text-xl text-ink-900 mb-2">{title}</h3>
                <p className="text-ink-600 font-body text-sm leading-relaxed">{text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <FaqSection className="bg-beige/60" emitSchema />
    </div>
  );
}
